import { render, staticRenderFns } from "./userInfoOther.vue?vue&type=template&id=06725e8e&scoped=true&"
import script from "./userInfoOther.vue?vue&type=script&lang=js&"
export * from "./userInfoOther.vue?vue&type=script&lang=js&"
import style0 from "./userInfoOther.vue?vue&type=style&index=0&id=06725e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06725e8e",
  null
  
)

export default component.exports